import { ChangeDetectorRef, Component, Inject } from '@angular/core';

import type { FullCandidate } from '@recruitee/candidate-types';
import {
  BoxComponent,
  DialogBodyComponent,
  DialogData,
  DialogHeaderComponent,
  SpinnerComponent,
} from '@recruitee/user-interface';

@Component({
  selector: 'rt-candidate-profile-photo-preview',
  templateUrl: './candidate-profile-photo-preview.component.html',
  styleUrls: ['./candidate-profile-photo-preview.component.less'],
  imports: [DialogHeaderComponent, DialogBodyComponent, BoxComponent, SpinnerComponent],
})
export class CandidateProfilePhotoPreviewDialogComponent {
  public candidate: FullCandidate = this.data.candidate;
  public loading: boolean = true;
  public photoUrl: string | null = null;

  constructor(
    @Inject(DialogData) private data: { candidate: FullCandidate },
    protected cdRef: ChangeDetectorRef,
  ) {}

  public ngOnInit(): void {
    this.loadCandidateImage();
  }

  private loadCandidateImage(): void {
    const candidatePreview = new Image();
    candidatePreview.onload = () => {
      this.photoUrl = candidatePreview.src;
      this.loading = false;
      this.cdRef.detectChanges();
    };
    candidatePreview.src = this.candidate.photoUrl;
  }
}
